import { createContext, useContext, type ReactNode } from "react";
import { useLocalStorage } from "@/hooks";

export type Theme = "cream" | "butter" | "lavender";
export const THEMES: Theme[] = ["cream", "butter", "lavender"];

interface ThemeApi {
    theme: Theme;
    setTheme: (t: Theme) => void;
}

const Ctx = createContext<ThemeApi | null>(null);

export function ThemeProvider({ children }: { children: ReactNode }) {
    const [theme, setTheme] = useLocalStorage<Theme>("krithios:theme", "cream");
    return <Ctx.Provider value={{ theme, setTheme }}>{children}</Ctx.Provider>;
}

export function useTheme(): ThemeApi {
    const ctx = useContext(Ctx);
    if (!ctx) throw new Error("useTheme must be used inside ThemeProvider");
    return ctx;
}
